module.exports = __webpack_public_path__ + "static/img/jxle.c8b5857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jxle.png
// module id = KdPZ
// module chunks = 1